module.exports = __webpack_public_path__ + "img/obs_snow_0.bf046c93.svg";